import { TextField } from "@mui/material";

const OutlinedTextField = (rest) => (
  <TextField
 
    {...rest}
    variant="outlined"
  />
);

export default OutlinedTextField;
